import React, { useEffect, useState } from 'react';
import styles from './styles.module.css';
import { useDispatch, useSelector } from 'react-redux';
import { setPage } from '../../actions/schoolYears';
import { getEducationalStructures, getReport } from '../../actions/educationalStructure';
import { getTeachersList } from '../../actions/common';
import Modal from './Modal';
import EducationalTreeTable from './EducationalTreeTable';
import ReportModal from './ReportModal';
import { useEducationalTree } from './hooks';
import Confirmation from '../../components/Confirmation/Confirmation';
import 'primereact/resources/themes/lara-light-cyan/theme.css';
import 'primereact/resources/primereact.min.css';

export default function EducationalStructure() {
  const dispatch = useDispatch();

  const [modalOpen, setModalOpen] = useState(null);
  const [confirmation, setConfirmation] = useState(false);
  const [confirmationTitle, setConfirmationTitle] = useState('Удалить элемент');
  const [reportType, setReportType] = useState('class');
  const [reportCategory, setReportCategory] = useState('');
  const [reportOpen, setReportOpen] = useState(false);

  const { report } = useSelector((state) => state.educational_structure);

  const {
    treeNodes,
    selectedNode,
    setSelectedNode,
    expandedKeys,
    setExpandedKeys,
    getSelectedNodeData,
    getSelectedNodeChildrenCount,
    moveUp,
    moveDown,
    indentNode,
    outdentNode,
    deleteNode,
    expandAll,
    collapseAll,
    canMoveUp,
    canMoveDown,
    canIndent,
    canOutdent,
    hasSelection,
    pending,
  } = useEducationalTree();

  useEffect(() => {
    dispatch(setPage(0));
    dispatch(getEducationalStructures());
    dispatch(getTeachersList());
  }, [dispatch]);

  const handleEdit = () => {
    const selectedData = getSelectedNodeData();
    if (selectedData) {
      setModalOpen(selectedData);
    }
  };

  const handleDoubleClick = (nodeData) => {
    setModalOpen(nodeData);
  };

  const handleAdd = () => {
    const selectedData = getSelectedNodeData();
    setModalOpen({
      addMode: 'addMode',
      owner_did: selectedData ? selectedData.did : 0,
    });
  };

  const handleDelete = () => {
    const selectedData = getSelectedNodeData();
    if (selectedData) {
      const childrenCount = getSelectedNodeChildrenCount();
      setConfirmationTitle(
        childrenCount > 0
          ? `Удалить элемент вместе со всеми дочерними узлами (${childrenCount})?`
          : 'Удалить элемент'
      );
      setConfirmation(selectedData.name);
    }
  };

  const acceptConfirmation = () => {
    deleteNode();
    setConfirmation(false);
  };

  const closeModal = () => {
    setModalOpen(null);
  };

  const handleReportTypeChange = (type) => {
    setReportType(type);
  };

  const handleRunReport = async () => {
    const data = await dispatch(getReport(reportType, 0, reportCategory));
    if (data) setReportOpen(true);
  };

  return (
    <div className={styles.wrapper}>
      {confirmation && (
        <Confirmation
          top="30px"
          left="40px"
          title={confirmationTitle}
          confirmation={confirmation}
          acceptConfirmation={acceptConfirmation}
          rejectConfirmation={() => setConfirmation(false)}
        />
      )}
      <Modal
        modalOpen={modalOpen}
        isOpen={!!modalOpen}
        closeModal={closeModal}
      />

      {reportOpen && (
        <ReportModal report={report} onClose={() => setReportOpen(false)} />
      )}

      <h1>Учебная структура</h1>

      <EducationalTreeTable
        treeNodes={treeNodes}
        selectedNode={selectedNode}
        setSelectedNode={setSelectedNode}
        expandedKeys={expandedKeys}
        setExpandedKeys={setExpandedKeys}
        onDoubleClick={handleDoubleClick}
        onAdd={handleAdd}
        onDelete={handleDelete}
        onEdit={handleEdit}
        onMoveUp={moveUp}
        onMoveDown={moveDown}
        onIndent={indentNode}
        onOutdent={outdentNode}
        onExpandAll={expandAll}
        onCollapseAll={collapseAll}
        canMoveUp={canMoveUp}
        canMoveDown={canMoveDown}
        canIndent={canIndent}
        canOutdent={canOutdent}
        hasSelection={hasSelection}
        pending={pending}
        reportType={reportType}
        reportCategory={reportCategory}
        onReportTypeChange={handleReportTypeChange}
        onReportCategoryChange={setReportCategory}
        onRunReport={handleRunReport}
      />
    </div>
  );
}
